import React from 'react';
import { 
  FaMapMarker, 
  FaHeart, 
  FaStar, 
  FaGasPump, 
  FaTachometerAlt,
  FaCalendar,
  FaCog,
  FaCarSide,
  FaMoneyBillWave,
  FaCertificate
} from 'react-icons/fa';

const ListingCard = ({ listing, onNavigate, onFavorite, isFavorite, message }) => {
  return (
    <div
      onClick={() => onNavigate(listing.id)}
      className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border border-gray-100 overflow-hidden relative"
    >
      {/* Image Section */}
      <div className="relative aspect-video">
        <img
          src={listing.image}
          alt={listing.title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-102"
          loading="lazy"
        />
        
        {/* Top Badges */}
        <div className="absolute top-0 left-0 right-0 flex justify-between items-start p-3">
          {/* Featured Badge */}
          {listing.featured && (
            <div className="bg-gradient-to-r from-emerald-600 to-green-500 text-white px-3 py-1.5 text-xs font-semibold rounded-full flex items-center gap-2">
              <FaStar className="text-yellow-300" />
              WYRÓŻNIONE
            </div>
          )}
        </div>

        {/* Favorite Button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onFavorite(listing.id);
          }}
          className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-full p-2.5 shadow-sm hover:bg-gray-50 transition-all duration-300"
          aria-label={isFavorite ? 'Usuń z ulubionych' : 'Dodaj do ulubionych'}
        >
          <FaHeart className={`text-xl ${isFavorite ? 'text-red-600 fill-current' : 'text-gray-400'}`} />
        </button>
      </div>

      {/* Content Section */}
      <div className="p-4 space-y-4">
        {/* Title Section */}
        <div className="space-y-1">
          <h3 className="text-xl font-bold text-gray-900 truncate">{listing.title}</h3>
          <p className="text-gray-500 text-sm flex items-center gap-1">
            <FaCertificate className="text-gray-400" />
            {listing.subtitle}
          </p>
        </div>

        {/* Specifications Grid */}
        <div className="grid grid-cols-2 gap-3">
          <SpecItem 
            icon={<FaGasPump className="text-gray-500" />}
            label="Paliwo"
            value={listing.fuel}
          />
          <SpecItem 
            icon={<FaTachometerAlt className="text-gray-500" />}
            label="Przebieg"
            value={listing.mileage}
          />
          <SpecItem 
            icon={<FaCalendar className="text-gray-500" />}
            label="Rok"
            value={listing.year}
          />
          <SpecItem 
            icon={<FaCog className="text-gray-500" />}
            label="Moc"
            value={listing.power}
          />
          <SpecItem 
            icon={<FaCarSide className="text-gray-500" />}
            label="Napęd"
            value={listing.drive}
          />
          <SpecItem 
            icon={<FaMapMarker className="text-gray-500" />}
            label="Lokalizacja"
            value={`${listing.city} (${listing.location})`}
          />
        </div>

        {/* Price & Location */}
        <div className="border-t border-gray-100 pt-4 flex justify-between items-center">
          <div className="flex items-center text-gray-600">
            <FaMapMarker className="text-red-500 mr-1.5" />
            <span className="text-sm font-medium">
              {listing.city}
            </span>
          </div>
          <div className="bg-gradient-to-r from-gray-900 to-gray-700 text-white px-4 py-2 rounded-full flex items-center gap-2">
            <FaMoneyBillWave className="text-lg" />
            <span className="font-bold text-lg">
              {listing.price.toLocaleString('pl-PL')} zł
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

// Reusable Spec Item Component
const SpecItem = ({ icon, label, value }) => (
  <div className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded-lg transition-colors">
    <div className="text-gray-400 p-1.5 bg-gray-100 rounded-lg">
      {icon}
    </div>
    <div className="flex-1">
      <div className="text-xs text-gray-500 font-medium">{label}</div>
      <div className="text-sm font-semibold text-gray-900">{value}</div>
    </div>
  </div>
);

export default ListingCard;